import { atomWithStorage, createJSONStorage } from "jotai/utils";

const storage = createJSONStorage<string>(() => localStorage);

export const currentWorkspaceIdAtom = atomWithStorage<string>(
  "workspaceId",
  "",
  storage
);
